import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Bell, Loader2, X } from "lucide-react";
import { toast } from "sonner";

export function SavedSearchDialog({
  filters,
  onClose,
}: {
  filters: Record<string, unknown>;
  onClose: () => void;
}) {
  const [email, setEmail] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSaving(true);
    const { error } = await supabase.from("saved_searches").insert({
      email: email.trim().toLowerCase(),
      filters: filters as never,
    });
    setSaving(false);
    if (error) {
      toast.error(error.message);
    } else {
      toast.success("¡Listo! Te avisaremos por email cuando haya coincidencias.");
      onClose();
    }
  };

  return (
    <div className="fixed inset-0 z-50 grid place-items-center bg-black/60 p-4">
      <div className="relative w-full max-w-md rounded-2xl bg-background p-6 shadow-xl">
        <button
          onClick={onClose}
          className="absolute right-3 top-3 rounded-full p-1.5 text-muted-foreground hover:bg-secondary"
        >
          <X className="h-4 w-4" />
        </button>
        <div className="mb-4 flex items-center gap-2">
          <div className="grid h-10 w-10 place-items-center rounded-full bg-accent/15 text-accent">
            <Bell className="h-5 w-5" />
          </div>
          <div>
            <h3 className="font-semibold">Recibir alertas por email</h3>
            <p className="text-xs text-muted-foreground">
              Te avisamos cuando aparezcan propiedades que coincidan.
            </p>
          </div>
        </div>

        <form onSubmit={submit} className="space-y-3">
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="tu@email.com"
            className="w-full rounded-md border border-input bg-background px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-ring"
          />
          <div className="rounded-lg bg-secondary/60 p-3 text-xs text-muted-foreground">
            Filtros guardados:{" "}
            {Object.entries(filters)
              .filter(([, v]) => v !== "" && v != null)
              .map(([k, v]) => `${k}: ${v}`)
              .join(" · ") || "(sin filtros)"}
          </div>
          <button
            type="submit"
            disabled={saving}
            className="inline-flex w-full items-center justify-center gap-2 rounded-md bg-primary px-4 py-2.5 text-sm font-semibold text-primary-foreground hover:brightness-110 disabled:opacity-60"
          >
            {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : <Bell className="h-4 w-4" />}
            Guardar alerta
          </button>
        </form>
      </div>
    </div>
  );
}
